import { Dialog, styled } from '@mui/material';

const StyledDialog = styled(Dialog)({
  '& .MuiDialogTitle-root': {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  '& .MuiDialogContent-root': {
    '& .MuiTypography-body1': {
      fontSize: 14,
      lineHeight: '16px',
      '& strong': {
        fontWeight: 600,
      },
    },
    '& .MuiTypography-body2': {
      fontStyle: 'italic',
    },
  },
});

export default StyledDialog;
